
const hasPassiveEvents = (function () {
    if (typeof window !== 'undefined' && typeof window.addEventListener === 'function') {
        let passive = false;

        const options = Object.defineProperty({}, 'passive', {
            get() { passive = true; },
        });

        const noop = () => {};
        window.addEventListener('testPassiveEventSupport', noop, options);
        window.removeEventListener('testPassiveEventSupport', noop, options);
        return passive;
    }
})();

!(function (window, document, undefined) {
    'use strict';

    let canScroll = true;

    const $window = $(window);

    const Scroll = {
        y: $window.scrollTop(),
        inAnimation: false,
    };

    window.addEventListener('wheel', function (event) {
        if ($(event.target).closest('.sidebar').length) {
            event.stopPropagation();

            return false;
        }

        if (!canScroll) {
            event.preventDefault();
            return false;
        }

        if (!Is.mobile.ANY() && !$body.is('.modal-opened') && !$body.is('.pause-scroll') && !Is.desktop.MAC()) {
            event.preventDefault();

            let maxScroll = $(document).height() - $(window).height();
            let delta = event.deltaY > 0 ? -1 : 1;

            Scroll.y = Scroll.y - parseInt(delta * 80);
            Scroll.y = Scroll.y < 0 ? 0 : Scroll.y;
            Scroll.y = Scroll.y > maxScroll ? maxScroll : Scroll.y;

            TweenMax.killTweensOf(this);
            TweenMax.to(this, .8, {scrollTo : { y: Scroll.y }, ease: Power2.easeOut,
                onStart:        () => Scroll.inAnimation = true,
                onComplete:     () => Scroll.inAnimation = false,
            });
        }
    }, hasPassiveEvents ? { passive: false } :  false);

    window.addEventListener('scroll', function () {
        if (!Scroll.inAnimation) {
            Scroll.y = $window.scrollTop();
        }
    });

    window.Scroll = Scroll;
})(window, document, undefined);
